import Icon from "./icons/Icon";
import "./Sheet.css";

/**
 * Bottom-Sheet: legt sich von unten ueber den Bildschirm, Hintergrund
 * abgedunkelt. Antippen daneben schliesst. mitX: Titelzeile mit X (Dialoge);
 * fuss: Knoepfe unten, scrollen nicht mit. mitte: in der Mitte statt unten
 * (Ansagen wie "Wiederholung").
 * @category bausteine
 */
export function Sheet({ titel, onClose, children, className, mitX = false, fuss, mitte = false }) {
  return (
    <div className={`sheet-hintergrund${mitte ? " mitte" : ""}`} onClick={onClose} role="presentation">
      <div
        className={["sheet", className].filter(Boolean).join(" ")}
        role="dialog"
        aria-modal="true"
        aria-label={titel}
        onClick={(e) => e.stopPropagation()}
      >
        {!mitte && <span className="sheet-griff" aria-hidden="true" />}
        {titel && mitX ? (
          <div className="sheet-kopf">
            <h2 className="sheet-titel">{titel}</h2>
            <button type="button" className="sheet-zu" onClick={onClose} aria-label="Schließen" title="Schließen">
              <Icon name="x" />
            </button>
          </div>
        ) : (
          titel && <h2 className="sheet-titel">{titel}</h2>
        )}
        {mitX || fuss ? <div className="sheet-inhalt">{children}</div> : children}
        {fuss && <div className="sheet-fuss">{fuss}</div>}
      </div>
    </div>
  );
}

export default Sheet;
